var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSchedule = function SvgIconSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12a6 6 0 1 0 0 12 6 6 0 0 0 0-12m3 7h-2v2h-2v-2h-2v-2h2v-2h2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 3h-5V1a1 1 0 0 0-2 0v2H8V1a1 1 0 1 0-2 0v2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h9v-2H2V7h20v4h2V4a1 1 0 0 0-1-1"
  })))));
};
export { SvgIconSchedule as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xOCAxMmE2IDYgMCAxIDAgMCAxMiA2IDYgMCAwIDAgMC0xMnptMyA3aC0ydjJoLTJ2LTJoLTJ2LTJoMnYtMmgydjJoMnYyeiIvPgogICAgICAgICAgICA8cGF0aCBkPSJNMjMgM2gtNVYxYTEgMSAwIDAgMC0yIDB2Mkg4VjFhMSAxIDAgMSAwLTIgMHYySDFhMSAxIDAgMCAwLTEgMXYxOGExIDEgMCAwIDAgMSAxaDl2LTJIMlY3aDIwdjRoMlY0YTEgMSAwIDAgMC0xLTF6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";